<script setup lang="ts">
import GwText from '@/components/lib/base/GwText/GwText.vue'
import GwIcon from '@/components/lib/GwIcon/GwIcon.vue'
import GwBox from '@/components/lib/GwBox/GwBox.vue'
import StatChart from '@/components/hhv3/Analyzer/StatsBoxes/StatChart.vue'
import { type GwIconVariants } from '@/components/lib/GwIcon/GwIcon.vue'
import StatRow, { type StatRowProps } from '@/components/hhv3/Analyzer/StatsBoxes/StatRow.vue'

export interface StatsBoxProps extends StatRowProps {
  icon: string
  iconVariant: GwIconVariants
  chart?: {
    id: string
    value?: number[]
  }
  extra?: StatRowProps[]
}
const props = defineProps<StatsBoxProps>()
</script>

<template>
  <GwBox
    variant="box_gradient180_bordered"
    class="d-flex f-row justify-between w-100"
    style="gap: var(--app-gap-2); padding: var(--app-pad-4); border-radius: var(--app-pad-3)"
    :loading
  >
    <div
      class="f-column flex-1"
      style="gap: var(--app-gap-2)"
    >
      <GwIcon
        :icon="icon"
        :variant="iconVariant"
      />
      <GwText
        variant="text_grey_normal_500"
        class="text-nowrap"
      >
        {{ title }}
      </GwText>

      <div class="d-flex f-row justify-space-between w-100 f-wrap">
        <StatRow v-bind="props" />
        <StatRow
          v-for="e in extra"
          v-bind="e"
          :loading
        />
      </div>
    </div>
    <StatChart
      v-if="chart && (chart.value?.length || 0) > 2"
      class="flex-0-1-100"
      style="max-width: 14rem; margin-top: 0.5rem; margin-left: 2rem"
      :points="chart.value"
    />
  </GwBox>
</template>
